
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 26","fill":"#0C1D59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.752 1.123a1 1 0 00-1.019-.008L1.472 6.503a1 1 0 00-.497.864v11.265a1 1 0 00.516.876l9.749 5.387a1 1 0 00.986-.01l9.261-5.388a1 1 0 00.497-.865V7.858v-.001A1 1 0 0021.501 7l-9.749-5.878zm8.232 8.473l-7.26 4.224v8.462l7.26-4.225V9.596zm-9.26 4.214l-4.391-2.648-3.358-2.024v8.905l7.748 4.282V13.81zm-3.88-4.674L3.937 7.383l7.29-4.241 2.713 1.636-7.096 4.358zm1.929 1.162l7.096-4.357 3.153 1.9-7.29 4.242-2.96-1.785z"}})])
          )
        }
      }
    